var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 0h-6.75A5.626 5.626 0 000 5.625v6.75A5.626 5.626 0 005.625 18h6.75A5.626 5.626 0 0018 12.375v-6.75A5.626 5.626 0 0012.375 0zm3.938 12.375a3.942 3.942 0 01-3.938 3.938h-6.75a3.942 3.942 0 01-3.938-3.938v-6.75a3.942 3.942 0 013.938-3.938h6.75a3.942 3.942 0 013.938 3.938v6.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.313A2.816 2.816 0 016.187 9 2.816 2.816 0 019 6.187 2.816 2.816 0 0111.813 9 2.816 2.816 0 019 11.813zM13.838 4.762a.6.6 0 100-1.2.6.6 0 000 1.2z"
  })));
}

export default SvgSocialInstagram;